import { Injectable } from "@angular/core";
import { IStep } from "@interfaces/step.interface";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StepsService {
  private stepsSource: IStep[] = [];

  set steps(value: IStep[]) {
    this.stepsSource = value;
  }

  get steps(): IStep[] {
    return this.stepsSource;
  }

  public actualStep: number = 0;
  private readonly currentStep$ = new BehaviorSubject<number>(0);
  private readonly showStepper$ = new BehaviorSubject<boolean>(true);

  get currentStep(): Observable<number> {
    return this.currentStep$.asObservable();
  }
  
  get showStepper(): Observable<boolean> {
    return this.showStepper$.asObservable();
  }

  setShowStepper(value: boolean) {
    this.showStepper$.next(value);
  }
  
  setCurrentStep(value: number) {
    this.actualStep = value;
    this.currentStep$.next(value);
  }

}
